import { ACTIONS } from '../const';
import moment from 'moment';
import { switcher, toID } from './utils';

const first = (head, ...tail) =>
    tail.length == 0 || head != null ? head : first(...tail);

const localShape = data => ({
    created: moment().format('YYYY-MM-DDTHH:mm:ss.SSSSSS'),
    ...data,
    content_id: first(data.content_id, toID(data.content)),
});

const get = (obj, propname) => {
    if (obj != null) {
        if (obj.get) {
            return obj.get(propname);
        }
        return obj[propname];
    }
};

const getDefault = (obj, propname, d) => {
    const result = get(obj, propname);
    return result != null ? result : d;
};

export default switcher([], {
    [ACTIONS.BOOKMARK_BUNDLE](state, action) {
        const { bundle, content_id } = action;

        const contentBookmarks = bundle.objects
            .map(localShape)
            .reduce((tmp, bookmark) => {
                return [...tmp, bookmark];
            }, []);

        return {
            ...state,
            [content_id]: contentBookmarks,
        };
    },
    [ACTIONS.SET_BOOKMARK](state, action) {
        const { id = null, content_id, page } = action.payload;

        const bookmark = localShape({
            id,
            content_id,
            page,
        });

        const content = getDefault(state, content_id, []);

        return {
            ...state,
            [content_id]: content.concat([bookmark]),
        };
    },
    [ACTIONS.REMOVE_BOOKMARK](state, action) {
        const { content_id, page } = action.payload;
        const content = getDefault(state, content_id, []);

        return {
            ...state,
            [content_id]: content.filter(b => b.page != page),
        };
        // return state.deleteIn([content_id, page])
    },
});



// WEBPACK FOOTER //
// ./src/reducers/bookmarks.js